import { APPSERVER_API_PREFIX } from '@/main/app.constants';
import { getAxiosInstance } from '@/requests/axios.utilities';
import { getHref } from '@/utilities/utilities';
import type { AxiosPromise } from 'axios';
import type { ItemOutputV1 } from '@seeqdev/api/model/ItemOutputV1';

export function getItemForTool(item: ItemOutputV1): AxiosPromise {
  return getAxiosInstance().get(APPSERVER_API_PREFIX + getHref(item));
}
